<div class="wetter_content_container">
  <h3>Vorhersagen</h3>
  <div class="bericht-text-container">
    <span class="bericht-text-sub-label">{{langWetterVorhersage?.tag00?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{langWetterVorhersage?.tag00?.kurzbeschreibung}}</p>
  </div>

  <div class="bericht-text-container">
    <span class="bericht-text-sub-label">{{langWetterVorhersage?.nachtZuTag01?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{langWetterVorhersage?.nachtZuTag01?.kurzbeschreibung}}</p>
    <span class="bericht-text-sub-label">{{langWetterVorhersage?.tag01?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{langWetterVorhersage?.tag01?.kurzbeschreibung}}</p>
  </div>

  <h3>Aussichten</h3>
  <div class="bericht-text-container" *ngFor="let aussicht of langWetterAussichtenTageMitNaechte">
    <div *ngIf="aussicht?.nachtZuTag">
      <span class="bericht-text-sub-label">Nacht zu {{aussicht?.nachtZuTag?.datum | date: 'EEE dd.MM'}}</span>
      <p>{{aussicht?.nachtZuTag?.kurzbeschreibung}}</p>
    </div>
    <div *ngIf="aussicht?.tag">
      <span class="bericht-text-sub-label">{{aussicht?.tag?.datum | date: 'EEE dd.MM'}}</span>
      <p>{{aussicht?.tag?.kurzbeschreibung}}</p>
    </div>
  </div>
</div>
